module.exports = __webpack_public_path__ + "static/media/Image_OB_Plus.f8c2948b.png";